<style lang="scss">
.monitorEfficiencyTable .el-progress-bar__outer {
  background: #606672;
}

.monitorEfficiencyTable .el-progress__text {
  color: #ffffff;
}

.monitorEfficiencyTable::before {
  z-index: inherit;
}

.monitorEfficiencyTable.el-table {
  background-color: transparent;
}

.monitorEfficiencyTable.el-table--border:after,
.monitorEfficiencyTable.el-table--group:after,
.monitorEfficiencyTable.el-table:before {
  background-color: transparent;
}

.monitorEfficiencyTable.el-table tr {
  background-color: transparent;
}

.monitorEfficiencyTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorEfficiencyTable .el-table td.gutter,
.monitorEfficiencyTable.el-table th.gutter {
  background: #33333a;
}

.monitorEfficiencyTable .el-table__body-wrapper {
  background: #1d1d24;
}

// 滚动条的宽度
.monitorEfficiencyTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

//滚动条的滑块
.monitorEfficiencyTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

// .monitorEfficiencyTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
      <div style="display: flex;align-items: center;">
        <span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
        <p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
          {{ $t('xiaolvzhibiao') }}
        </p>
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }">
      <el-table ref="table" class="monitorEfficiencyTable" :data="progresses" style="width: 100%" :max-height="contentHeight" :row-style="{ background: '#1D1D24', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: '#202027', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: '#33333A', color: '#C0C4CC', padding: '0px', height: '42px', borderColor: '#33333A' }">
        <el-table-column prop="equipmentName" :label="$t('shebeimingcheng')"> </el-table-column>
        <el-table-column prop="startupRate" :label="$t('kaijilu') + '(%)'"> </el-table-column>
        <el-table-column prop="runRate" :label="$t('jiadonglu') + '(%)'"> </el-table-column>
        <el-table-column prop="runDuration" :label="$t('yunxingshijian') + '(h)'"> </el-table-column>
        <el-table-column prop="idleDuration" :label="$t('kongxianshijian') + '(h)'"> </el-table-column>
        <el-table-column prop="errorDuration" :label="$t('guzhangshijian') + '(h)'"> </el-table-column>
        <el-table-column prop="shutdownDuration" :label="$t('lixianshijian') + '(h)'"> </el-table-column>
        <el-table-column :label="$t('shebeiyunxingzhuangkuang')">
          <template slot-scope="scope">
            <div style="background: #7582A3;height: 16px;width: 100%;display: flex;">
              <div style="height: 20px;" :style="{ width: status.percent * 100 + '%', background: statusColors[status.s] }" v-for="status in scope.row.status">
                <!-- {{status.last}} -->
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_efficiency_efficiency',
  components: {},
  data() {
    return {
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      progresses: [],
      statusColors: ['#7DFFBE', '#FFD580', '#FF809F', '#7582A3'],
      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.getEfficiency();
    }, 600000);
    this.getEfficiency();
  },
  watch: {
    '$attrs.shift'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEfficiency();
    },
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.getEfficiency();
    }
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  activated() {
    this.resize();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async getEfficiency() {
      let response = await this.http.get('/web/board/efficiency/index/board/list', { params: { orgId: this.$attrs.orgId } });
      this.progresses = response.data;
      for (var i = 0; i < this.progresses.length; i++) {
        this.progresses[i].startupRate = (this.progresses[i].startupRate * 100).toFixed(1);
        this.progresses[i].runRate = (this.progresses[i].runRate * 100).toFixed(1);
        this.progresses[i].runDuration = (this.progresses[i].runDuration / 3600 / 1000).toFixed(1);
        this.progresses[i].idleDuration = (this.progresses[i].idleDuration / 3600 / 1000).toFixed(1);
        this.progresses[i].errorDuration = (this.progresses[i].errorDuration / 3600 / 1000).toFixed(1);
        this.progresses[i].shutdownDuration = (this.progresses[i].shutdownDuration / 3600 / 1000).toFixed(1);

        //总时长
        this.progresses[i].status = this.progresses[i].status.map(item => {
          item.last = (this.dayjs(item.et).unix() - this.dayjs(item.st).unix()) / 3600;
          return {
            percent: item.last / 24,
            s: item.s,
            st: item.st,
            et: item.et,
            name: '',
            type: 'bar',
            stack: 'total',
            label: {
              show: false
            },
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              normal: {
                color: this.statusColors[item.s],
                barBorderRadius: 0
              }
            },
            data: [item.last]
          };
        });

        if (this.progresses[i].equipmentName == '24') {
          console.log(this.progresses[i].status);
        }
      }
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;

          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 8;
      }, 800);
    }
  }
};
</script>
